import { Link } from 'react-router-dom';
import styles from './NewsCard.module.css';

interface NewsCardProps {
  to: string;
  image: string;
  date: string;
  title: string;
  tag?: string;
}

export default function NewsCard({ to, image, date, title, tag }: NewsCardProps) {
  return (
    <Link className={styles.card} to={to}>
      <div className={styles.imageWrapper}>
        {/* Sin `src` no se pinta la etiqueta: un src vacio hace que el
            navegador vuelva a pedir la pagina entera. El API admite noticias
            sin imagen (`image: null` en el contrato). */}
        {image ? <img className={styles.image} src={image} alt={title} /> : null}
        {tag ? <span className={styles.tag}>{tag}</span> : null}
      </div>
      <div className={styles.body}>
        <div className={styles.date}>{date}</div>
        <h3 className={styles.title}>{title}</h3>
        <span className={styles.arrow}>Leer más →</span>
      </div>
    </Link>
  );
}
